/*
  Petits outils communs aux sections des pages de la boutique (collection, recherche, blog, contact, etc.).
  - [data-pg-copy] : bouton qui copie l'ancre d'une section dans le presse-papiers.
  - pastilles de couleur des cartes produit : au clic, la carte prend l'image, le prix et la variante de la couleur.
*/
(() => {
  if (window.pgPagesLoaded) return;
  window.pgPagesLoaded = true;

  const copyText = (text) => {
    const fallback = () => {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (error) {
        ok = false;
      }
      field.remove();
      return ok;
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(() => true, () => fallback());
    }
    return Promise.resolve(fallback());
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pg-copy]');
    if (!button) return;
    copyText(button.getAttribute('data-pg-copy')).then((ok) => {
      if (!ok) return;
      button.classList.add('is-copied');
      setTimeout(() => button.classList.remove('is-copied'), 2000);
    });
  });

  /* ---------- Pastilles de couleur d'une carte produit ---------- */
  const setText = (element, text) => {
    if (element && text) element.textContent = text;
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.card__swatch-input');
    if (!input) return;
    const card = input.closest('.card-wrapper');
    if (!card) return;
    const data = input.dataset;

    const image = card.querySelector('.card__media img');
    if (image && data.imageSrc) {
      image.src = data.imageSrc;
      if (data.imageSrcset) image.srcset = data.imageSrcset;
    }

    if (data.variantUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = data.variantUrl;
      });
    }

    const variantField = card.querySelector('form input[name="id"]');
    if (variantField && data.variantId) {
      variantField.value = data.variantId;
      variantField.disabled = data.variantAvailable !== 'true';
    }

    const price = card.querySelector('.price');
    if (price && data.price) {
      const onSale = Boolean(data.comparePrice);
      price.classList.toggle('price--on-sale', onSale);
      setText(price.querySelector('.price__regular .price-item--regular'), data.price);
      setText(price.querySelector('.price__sale .price-item--sale'), data.price);
      setText(price.querySelector('.price__sale s.price-item--regular'), data.comparePrice);
    }
  });
})();
